(() => {
  const loader = document.querySelector('[data-spectral-loader]');
  if (!loader) return;

  const percentEl = loader.querySelector('[data-loader-percent]');
  const progressEl = loader.querySelector('[data-loader-progress]');
  const markerEl = loader.querySelector('[data-loader-marker]');
  const stageEl = loader.querySelector('[data-loader-stage]');
  const statusEl = loader.querySelector('[data-loader-status]');
  const skipButton = loader.querySelector('[data-loader-skip]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');

  let seen = false;
  const forceIntro = new URLSearchParams(window.location.search).get('spectralIntro') === '1';
  try { seen = sessionStorage.getItem('spectral_intro_seen') === '1'; } catch (error) {}

  if (isDesignMode || reducedMotion) {
    loader.setAttribute('aria-hidden', 'true');
    return;
  }

  /*
   * This overlay is purely decorative. The real page underneath is server-rendered and
   * paints on its own — nothing here gates content readiness or blocks the main thread
   * with per-frame work, so Core Web Vitals (LCP in particular) reflect the real page,
   * not this splash. `overflow:hidden` below only stops background scroll while it's up.
   */
  document.documentElement.classList.add('spectral-loader-active');
  document.body.classList.add('spectral-loader-active');

  const isMobile = window.matchMedia('(max-width: 640px)').matches;
  const returning = seen && !forceIntro;

  // First-time visitors get the full brand moment (just over a second).
  // Returning visitors (this session) get a quick flash since they've already seen it.
  const duration = returning ? (isMobile ? 420 : 500) : (isMobile ? 1100 : 1250);
  const finishDuration = returning ? 280 : 550;

  loader.style.setProperty('--loader-duration', `${duration}ms`);
  loader.style.setProperty('--loader-finish-duration', `${finishDuration}ms`);

  // The bar fill and marker are pure CSS transitions (compositor-driven) — triggering
  // them is a single class toggle, not a loop.
  requestAnimationFrame(() => {
    progressEl?.classList.add('is-animating');
    markerEl?.classList.add('is-animating');
  });

  // Percent readout + stage text are cosmetic, so they update on a light interval
  // (~90ms ticks, a dozen or so total) instead of every animation frame.
  const stages = [
    ['INITIALIZING DESIGN SYSTEM', 'BOOTING CORE'],
    ['CALIBRATING RIDE DATA', 'CHECKING FITMENT'],
    ['LOADING COMPONENTS', 'SYNCING CATALOG'],
    ['VERIFYING ACCESSORIES', 'RUNNING QUALITY CHECK'],
    ['SYSTEM READY', 'SPECTRAL ONLINE'],
  ];

  const start = performance.now();
  let tickTimer = 0;

  const tick = () => {
    const elapsed = performance.now() - start;
    const progress = Math.min(100, Math.round((elapsed / duration) * 100));
    if (percentEl) percentEl.textContent = `${String(progress).padStart(2, '0')}%`;

    const stageIndex = progress < 25 ? 0 : progress < 47 ? 1 : progress < 72 ? 2 : progress < 94 ? 3 : 4;
    const [stage, status] = stages[stageIndex];
    if (stageEl) stageEl.textContent = stage;
    if (statusEl) statusEl.textContent = status;

    if (elapsed < duration) tickTimer = window.setTimeout(tick, 90);
  };
  tickTimer = window.setTimeout(tick, 0);

  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;
    window.clearTimeout(tickTimer);
    if (percentEl) percentEl.textContent = '100%';
    try { sessionStorage.setItem('spectral_intro_seen', '1'); } catch (error) {}
    loader.classList.add('spectral-loader--finishing');
    window.setTimeout(() => {
      loader.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('spectral-loader-active');
      document.body.classList.remove('spectral-loader-active');
    }, finishDuration);
  };

  skipButton?.addEventListener('click', finish);
  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') finish();
  }, { passive: true });

  // A fixed timer, not a wait on window 'load' — the splash's on-screen time is a
  // deliberate branding choice, not a proxy for "is the page ready yet."
  window.setTimeout(finish, duration);
})();